import { defineMessages } from 'react-intl';

export default defineMessages({
  homes: {
    id: 'global_mobile_sticky_homes_title',
    defaultMessage: 'Trovit Homes',
    description: 'homes',
  },
  cars: {
    id: 'global_mobile_sticky_cars_title',
    defaultMessage: 'Trovit Cars',
    description: 'cars',
  },
  jobs: {
    id: 'mobile_sticky_jobs_title',
    defaultMessage: 'Trovit Jobs',
    description: 'jobs',
  },
  products: {
    id: 'global_mobile_sticky_products_title',
    defaultMessage: 'Trovit Products',
    description: 'products',
  },
  downloadAppTopBannerSlogan: {
    id: 'global_wm_banner_app_download',
    defaultMessage: 'Download free app',
  },
  downloadAppTopBannerCTA: {
    id: 'global_trovitAds_backoffice_applies_download',
    defaultMessage: 'Download',
  },
  downloadAppBottomBannerSlogan: {
    id: 'global_mobile_sticky_global_claim',
    defaultMessage: "Even better with Trovit's app",
  },
  downloadAppBottomBannerCTA: {
    id: 'global_mobile_bottom_sticky_global_button',
    defaultMessage: 'Continue in App	',
  },
});



// WEBPACK FOOTER //
// ./app/DownloadAppBanner/messages.js